// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1788350216138
      var cssReload = require("/Users/pinjavaris/code/kopiosto/htdocs/wp-content/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  